import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { createLogger } from 'redux-logger';
import userReducer from './userSlice';
import { phoneVerificationApiSlice } from './api/phoneVerificationApiSlice';
import stripeReducer from './stripeSlice';
import insuranceReducer from './insuranceSlice';
import portalReducer from './portalSlice';
import saveProgressMiddleware from './middleware/saveProgressMiddleware';

const createPersistConfig = (key) => ({
  key,
  storage,
  debug: true,
  serialize: true,
});

const userPersistConfig = createPersistConfig('user');
const stripePersistConfig = createPersistConfig('stripe');
const insurancePersistConfig = createPersistConfig('insurance');
const portalPersistConfig = createPersistConfig('portal');

const persistedUserReducer = persistReducer(userPersistConfig, userReducer);
const persistedStripeReducer = persistReducer(stripePersistConfig, stripeReducer);
const persistedInsuranceReducer = persistReducer(insurancePersistConfig, insuranceReducer);
const persistedPortalReducer = persistReducer(portalPersistConfig, portalReducer);

const logger = createLogger({
  collapsed: true,
  duration: true,
});

const store = configureStore({
  reducer: {
    user: persistedUserReducer,
    stripe: persistedStripeReducer,
    insurance: persistedInsuranceReducer,
    portal: persistedPortalReducer,
    [phoneVerificationApiSlice.reducerPath]: phoneVerificationApiSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    })
      .concat(phoneVerificationApiSlice.middleware)
      .concat(saveProgressMiddleware);

    if (process.env.REACT_APP_ENV !== 'production') {
      return middleware.concat(logger);
    }

    return middleware;
  },
  devTools: process.env.REACT_APP_ENV !== 'production',
});

if (process.env.REACT_APP_ENV !== 'production') {
  store.subscribe(() => {
    const state = store.getState();
    console.log('Current state:', state);
  });
}

export const persistor = persistStore(store, null, () => {
  if (process.env.REACT_APP_ENV !== 'production') {
    console.log('Rehydration complete', store.getState());
  }
});

export default store;